export enum RcpOptionsEnum {
  TRUE = 'TRUE',
  FALSE = 'FALSE',
}

export enum RcpOptionsDescriptionEnum {
  TRUE = 'owner.details.system.rcp.true',
  FALSE = 'owner.details.system.rcp.false',
}
